module.exports = __webpack_public_path__ + "static/media/gettyimages-612009118-612x612.86548fd0.jpg";